module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("02XII"))).then(() => module.bundle.root('d0iPb'));